<template>
  <div>
    <ProtestedTaxList/>
    <ProtestedTaxFooter/>
  </div>
</template>
<script>
import ProtestedTaxFooter from '../../../components/tax/protestTax/ProtestedTaxFooter.vue';
import ProtestedTaxList from '../../../components/tax/protestTax/ProtestedTaxList.vue';

export default {
  name: 'ProtestedTax',
  components: {
    ProtestedTaxList,
    ProtestedTaxFooter,
  },
};
</script>
